import React, { useEffect, useState } from 'react';
import '../SignUp/SignUp.scss';
import './Login.scss';

import logo from '../../assets/images/DashboardImages/logo.svg';
import rightImg from '../../assets/images/DashboardImages/images/login-img.png';
import userIcon from '../../assets/images/DashboardImages/icons/iconamoon_profile.svg';
import emailIcon from '../../assets/images/DashboardImages/icons/mi_email.svg';
import passIcon from '../../assets/images/DashboardImages/icons/teenyicons_password-outline.svg';
import eyeIcon from "../../assets/icons/eye.svg"
import closeEyeIcon from "../../assets/icons/eyeclosed.svg"
import { Link, useNavigate } from 'react-router-dom';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { onAuthStateChanged, signInWithEmailAndPassword } from 'firebase/auth';
import { auth } from '../../config';

const emailRegex = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

const LogIn = () => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [showPassword, setShowPassword] = useState(false);
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();

    const isValid = validateInputs();

    if (isValid.email) {
      toast.error(isValid.email);
    }
    else if (isValid.password) {
      toast.error(isValid.password);
    }
    else {
      try {
        const userCred = await signInWithEmailAndPassword(
          auth,
          email,
          password
        );
        localStorage.setItem("isSigninSuccess", true);
        toast.success("Login success", { toastId: "userloggedin" });
        // console.log(auth.currentUser);



        navigate("/dashboard");

      } catch (error) {
        toast.error("Invalid Credentials", {
          toastId: "loginError",
        });
      }
    }


  };

  const validateInputs = () => {
    // setEmailError('');
    // setPasswordError('');
    let error = {}

    if (!email || !emailRegex.test(email)) {
      // setEmailError('Invalid email format');
      error = { ...error, email: 'Invalid email format' };
    }
    if (!password || password.length < 6) {
      // setPasswordError('Password must be at least 6 characters long');
      error = { ...error, password: 'Password must be at least 6 characters long' };
    }

    return error
  };

  useEffect(() => {
    // const auth = getAuth();
    const unsubscribe = onAuthStateChanged(auth, (user) => {
      if (user) {
        // User is signed in.
        const { uid } = user;
        navigate("/dashboard");
        // setUserisLogged(true);
      } else {
        // User is signed out.
        // setUserisLogged(false);

        // router.push({
        //     pathname: "/login",
        // });
      }
    });
    return () => unsubscribe();
  }, []);

  return (
    <div>
      <img src={logo} alt='' className='logo-dash' />
      <form className='credentional-main-container' onSubmit={handleSubmit}>
        <div className='credentional-main-left-container'>
          <div className='credentional-left-centered-container'>
            <h3>Log In</h3>

            <span>
              <img src={emailIcon} alt='' />
              <input type='text' placeholder='Email' value={email} onChange={(e) => setEmail(e.target.value)} />
            </span>
            <span>
              <img src={passIcon} alt='' />
              <input
                type={showPassword ? 'text' : 'password'}
                placeholder='Password'
                value={password}
                onChange={(e) => setPassword(e.target.value)}
              />
              {showPassword ? (
                <img
                  src={eyeIcon}
                  alt='Hide Password'
                  className='eye-icon'
                  onClick={() => setShowPassword(false)}
                />
              ) : (
                <img src={closeEyeIcon} alt='Show Password' className='eye-icon' onClick={() => setShowPassword(true)} />
              )}
            </span>

            <Link to='/resetpassword' className='forgotPass-Link'>
              <p>Forgot Password</p>
            </Link>

            <button type='submit' className='themebtn-1'>
              Log In
            </button>
            <p>
              Don’t have any account?<Link to='/signup' className='login-Link'>
                Sign Up
              </Link>
            </p>
          </div>
        </div>

        <div className='credentional-main-right-container'>
          <img src={rightImg} alt='' />
        </div>
      </form>
      <ToastContainer position='top-right' autoClose={3000} />
    </div>
  );
};

export default LogIn;
